import { inject } from '@angular/core';
import { HttpInterceptorFn} from '@angular/common/http';
import { TokenStorageUtil } from '../utils/token-storage.util';
import { APP_CONFIG } from '@ribera-web/app-token';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const storage = inject(TokenStorageUtil);

  const token = storage.get();

  const config = inject(APP_CONFIG);
  
  const apiUrlSecurity = config.SECURITY_MICROSERVICE_API;

  const isSecurityMs = req.url.includes(apiUrlSecurity);

  if (isSecurityMs) {
    const transactionId = '8FJ29DKQ1MZ73LPA';
    const applicationId = 'TX92KD7LQ1W8CZ0M';
    const processId = 'A8D7K3PQ92LM1ZFW';

    const authReq = req.clone({
      setHeaders: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'transactionId': transactionId,
        'applicationId': applicationId,
        'processId': processId
      }
    });
    return next(authReq);
  }

  // 2. Para las demás peticiones (como Booking), enviar solo el token o nada
  const standardReq = req.clone({
    setHeaders: {
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    }
  });
  
  return next(standardReq);
  // .pipe(
  //   catchError((err: any) => {
  //     if (err instanceof HttpErrorResponse && err.status === 401) {

  //       return from(authStore.refreshAccessToken()).pipe(
  //         switchMap(token => {
  //           if (!token) return throwError(() => err);

  //           const retryReq = req.clone({
  //             headers: req.headers.set('Authorization', `Bearer ${token}`)
  //           });
  //           return next(retryReq);
  //         })
  //       );
  //     }

  //     return throwError(() => err);
  //   })
  // );

};
